import { motion } from "framer-motion";

import { MAYA } from "../../lib/demoContent";
import { SceneCaption } from "./SceneCaption";

/** Scene 1 — open. Title card sits inside the same caption frame as every other scene. */
export const ScreenOpen = () => (
  <div className="max-w-3xl" data-testid="demo-scene-open">
    <SceneCaption eyebrow="A story · 75 seconds" title={`Meet ${MAYA.name}.`} />

    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, delay: 0.6 }}
      className="mt-5 border border-[#DDD9CF] bg-white rounded-md px-6 py-5 xl:px-7 xl:py-6"
    >
      <p className="text-base xl:text-lg text-[#1A1814] leading-relaxed">
        Senior PM at a B2B SaaS support platform. ~500 support agents across 30
        mid-market companies. ~2,000 tickets a day.
      </p>
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, delay: 1.6 }}
      className="mt-5 border border-[#DDD9CF] bg-white rounded-md px-6 py-5 xl:px-7 xl:py-6"
    >
      <div className="text-[10px] uppercase tracking-[0.20em] text-[#56534A] mb-2">
        The brief
      </div>
      <p className="font-serif-display italic text-lg xl:text-xl text-[#1A1814] leading-relaxed">
        Her CEO just asked her to ship AI-generated draft replies for incoming
        support tickets. Two weeks to brief engineering.
      </p>
    </motion.div>
  </div>
);
